import { render, staticRenderFns } from "./Estadisticas2022.vue?vue&type=template&id=00dc8a66&scoped=true"
import script from "./Estadisticas2022.vue?vue&type=script&lang=js"
export * from "./Estadisticas2022.vue?vue&type=script&lang=js"
import style0 from "./Estadisticas2022.vue?vue&type=style&index=0&id=00dc8a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc8a66",
  null
  
)

export default component.exports